import { render, staticRenderFns } from "./LegalRoles.vue?vue&type=template&id=4d327774&"
import script from "./LegalRoles.vue?vue&type=script&lang=js&"
export * from "./LegalRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports